import { WorkModel } from '@Entities/work/work'

const calculateTotalKnownShares = (workDraft: WorkModel | undefined) =>
    workDraft?.originalPublishers
        .map((op) => op.publisherShare ?? 0)
        .concat(
            workDraft?.originalPublishers.flatMap((op) =>
                op.administratorPublishers.map((ap) => ap.publisherShare ?? 0)
            )
        )
        .reduce((partialSum, a) => partialSum + a, 0) ?? 0
export default calculateTotalKnownShares
